import {
  POST,
  PUT,
} from "../../apiController";

const endpoint = "/admin/settings/support";

// ------------------- setting tickets (support questions)

// Get tickets with pagination, search and status filter
export const getTickets = (data) => {
  return POST(endpoint, data);
};

// Send ticket response and update status
export const sendTicketResponse = (id, data) => {
  return PUT(endpoint + `/${id}/response`, data);
};
